export default "__VITE_ASSET__sKveUtmt__"